<div class="home-content lao">
    <hr />
    <div class="page-body partner-grid">
      <div class="partner-card" *ngFor="let partner of partners">
        <div class="image-wrapper">
          <img [src]="partner.image" alt="{{ partner.name }}" class="partner-image" />
        </div>
        <p class="partner-name">{{ partner.name }}</p>
        <button class="partner-button" (click)="openDialog(partner)">View Details</button>
      </div>
    </div>
  </div>
  